import { getNews } from '@services/news/news.services';
import { useQuery } from '@tanstack/react-query';
import useIsLoggedIn from 'src/apis/queries/useIsLoggedIn';
import useUserPersonalData from 'src/apis/queries/useUserPersonalData';
import { newsKeys } from '../news.queriesKeys';

const useNews = () => {
	const { isLoggedIn } = useIsLoggedIn();
	const { lastConnectionDate } = useUserPersonalData();

	const { data = [], ...queryResult } = useQuery({
		queryKey: newsKeys.all,
		queryFn: () => getNews(lastConnectionDate),
		enabled: isLoggedIn && !!lastConnectionDate,
		staleTime: Infinity
	});

	return {
		latestNews: data[0],
		...queryResult
	};
};

export { useNews };
